import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";
import Shell from "../Shell";
import { authHeaders } from "../api";

export default function ApproveDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [item, setItem] = useState(null);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const { data } = await api.get(`/api/pending-users/${id}/`, {
          headers: authHeaders(),
        });
        if (!alive) return;
        setItem(data);
        setNote(data.reviewer_note || "");
      } catch (e) {
        // optional logging
      }
    })();

    return () => { alive = false; };
  }, [id]);

  const saveNote = async () => {
    setSaving(true);
    try {
      await api.patch(
        `/api/pending-users/${id}/`,
        { reviewer_note: note },
        { headers: authHeaders() }
      );
    } finally {
      setSaving(false);
    }
  };

  const approve = async () => {
    if (!window.confirm("Samþykkja þennan notanda?")) return;
    try {
      await api.post(`/api/pending-users/${id}/approve/`, {}, { headers: authHeaders() });
      nav("/members/approve");
    } catch (err) {
      const msg =
        err.response?.data?.errors ||
        err.response?.data?.detail ||
        err.response?.data?.trace ||
        "Upp kom villa við samþykki.";
      alert(typeof msg === "string" ? msg : JSON.stringify(msg));
    }
  };

  const deny = async () => {
    const ok = window.confirm("Viltu hafna beiðni?");
    if (!ok) return;
    await api.post(
      `/api/pending-users/${id}/deny/`,
      { reviewer_note: note },
      { headers: authHeaders() }
    );
    nav("/members/approve");
  };

  return (
    <Shell title="Hugarafl starfsfólk" rightMenu>
      {!item ? (
        <div>Hleð…</div>
      ) : (
        <>
          <h2 style={{ textAlign: "center", margin: "8px 0 18px" }}>
            Samþykkja nýjan félagsaðila {item.full_name}
          </h2>

          <div className="detail-grid">
            <div className="detail-left">
              <DL label="Notendanafn" value={item.username} />
              <DL label="Kennitala" value={item.ssn} />
              <DL label="Email" value={item.email} />
              <DL label="Símanúmer" value={item.phone_number} />
              <DL label="Sveitarfélag" value={item.place} />
              <DL label="Nánasti aðstandandi" value={item.next_of_kin} />
              <DL label="Símanúmer aðstandanda" value={item.phone_number_next_of_kin} />
              <DL label="Var þér vísað hingað?" value={item.referred_by} />
              <DL label="Hefur þú lokið nýliðakynningu?" value={item.has_completed_orientation ? "Já" : "Nei"} />
              <DL label="Byrjaði í Hugarafli" value={item.started_at_hugarafl} />
              <DL label="Samþykki fyrir sakavottorði" value={item.accepts_criminal_record_check ? "Já" : "Nei"} />
              <DL label="Kyn" value={item.gender} />
              <DL label="Samþykki húsreglur" value={item.accepts_house_rules ? "Já" : "Nei"} />
              <DL label="Trúnaðar­yfirlýsing" value={item.accepts_confidentiality_agreement ? "Já" : "Nei"} />
              {/* Updated: boolean informed_consent */}
              <DL
                label="Upplýst samþykki"
                value={
                  item.informed_consent === true
                    ? "Já"
                    : item.informed_consent === false
                    ? "Nei"
                    : "—"
                }
              />
            </div>

            <div className="detail-right">
              <div className="field">
                <span>Skrifa lýsingu um {item.full_name}</span>
                <textarea
                  rows={14}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
              <div style={{ textAlign: "center", marginTop: 8 }}>
                <button className="btn ghost" disabled={saving} onClick={saveNote}>
                  {saving ? "Vista…" : "Vista lýsingu"}
                </button>
              </div>
            </div>
          </div>

          <div className="detail-actions">
            <button className="btn" onClick={approve}>Samþykkja</button>
            <button className="btn danger" onClick={deny}>Ekki samþykkja</button>
          </div>
        </>
      )}
    </Shell>
  );
}

function DL({ label, value }) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ opacity: 0.7 }}>{label}:</div>
      <div>{value}</div>
    </div>
  );
}